<template>
    <div class="container-fluid mtb15 no-fluid order-rejected">
        <div class="card mb-3 w-100">
            <div class="card-body text-center">
                <img :src="rejectedIcon" class="order-rejected-icon" alt="">
                <h4 class="order-rejected-title">{{ getOrderNotPlacedLabel }}</h4>
                <p v-if="reason" class="order-rejected-reason">{{ reason }}</p>
                <p class="order-rejected-message">{{ message }}</p>
            </div>
            <div class="card-body pt-0">
                <table class="table order-rejected-table">
                    <tbody>
                        <tr v-for="row in orderRows" :key="row.label">
                            <td>{{ row.label }}</td>
                            <td>{{ row.value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import rejectedIcon from "@/assets/images/Cancelled.svg";

export default {
    props: {
        order: {
            required: true,
            type: Object
        },
        message: {
            required: true,
            type: String
        },
        reason: {
            default: "",
            type: String
        }
    },
    methods: {
        t(key, ...args) {
            return I18n.t(key, this.getUserLanguage, ...args);
        },
        formatNumber(value) {
            const numericValue = Number(value);
            return UiUtils.formatNumber(value, Number.isInteger(numericValue) ? 0 : 2);
        },
        formatPrice(value) {
            return UiUtils.formatPrice(value, this.order?.cc, this.getUserLanguage, 2).replace(" ", "\u00A0");
        }
    },
    computed: {
        rejectedIcon() {
            return rejectedIcon;
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        getOrderNotPlacedLabel() {
            return this.t("orderNotPlacedLabel");
        },
        stockTypeLabels() {
            return {
                equities: this.t("equitiesLabel"),
                bonds: this.t("bondsLabel"),
                compInstruments: this.t("compInstrumentsLabel"),
                funds: this.t("fundsLabel"),
                reits: this.t("reitsLabel"),
                rights: this.t("rightsLabel"),
                cfd: this.t("cfdLabel"),
                margin: this.t("marginLabel"),
                netting: this.t("nettingLabel"),
                repo: this.t("repoLabel"),
                stocksAndEtfs: this.t("stocksAndEtfsLabel"),
                other: this.t("othersLabel"),
                unknown: this.t("othersLabel")
            };
        },
        instrumentTypeLabel() {
            return getStockTypeLabel(this.order?.stid, this.stockTypeLabels);
        },
        quantityLabel() {
            return 2 === parseInt(this.order?.stid)
                ? this.t("faceValueLabel")
                : this.t("quantityLabel");
        },
        restrictionLabel() {
            return this.order?.restriction
                ? this.order.restriction
                : this.t("noRestrictionsLabel");
        },
        tradeAtCloseLabel() {
            return true === this.order?.tac
                ? this.t("yesLabel")
                : this.t("noLabel");
        },
        orderRows() {
            return [
                { label: this.t("typeLabel"), value: this.order?.action },
                { label: this.t("orderTypeLabel"), value: this.order?.type },
                { label: this.t("codeLabel"), value: this.order?.code },
                { label: this.t("nameLabel"), value: this.order?.name },
                { label: this.t("exchangeLabel"), value: this.order?.ex },
                { label: this.t("segmentLabel"), value: this.order?.segment },
                { label: this.t("instrumentTypeLabel"), value: this.instrumentTypeLabel },
                { label: this.t("validityLabel"), value: this.order?.expiry_date },
                { label: this.t("restrictionsLabel"), value: this.restrictionLabel },
                { label: this.t("tradeAtCloseLabel"), value: this.tradeAtCloseLabel },
                { label: this.quantityLabel, value: this.formatNumber(this.order?.amount) },
                { label: this.t("estimatedTotalLabel"), value: this.formatPrice(this.order?.price) }
            ];
        }
    }
};
</script>

<style scoped>
    .order-rejected-icon {
        height: 5rem;
        width: 5rem;
    }

    .order-rejected-title {
        margin: 0.75rem 0 0.35rem;
    }

    .order-rejected-message {
        color: #d62228;
        margin-bottom: 0;
    }

    .order-rejected-reason {
        font-weight: 600;
        margin-bottom: 0.25rem;
    }

    .order-rejected-table td {
        border-bottom: 1px solid #eee;
        padding: 0.35rem 0.5rem;
        vertical-align: middle;
    }

    .order-rejected-table td:last-child {
        font-weight: 700;
        text-align: right;
    }
</style>
